// src/hooks/useSubscriptionStats.ts
import { useMemo } from "react";
import { useSubscriptionsStore } from "../store/subscriptions";
import { BillingSubscription } from "../../../types/subscription";


export function useSubscriptionStats() {
  const { subscriptions } = useSubscriptionsStore();

  return useMemo(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const newSubscriptionsPerMonth = Array(12).fill(0);
    const renewalsPerMonth = Array(12).fill(0);

    let activeCount = 0;
    let expiredCount = 0;

    subscriptions.forEach((sub: BillingSubscription) => {
      const createdAt = new Date(sub.created_at);
      const subYear = createdAt.getFullYear();
      const subMonth = createdAt.getMonth();

      // --- Count new subscriptions (this year only) ---
      if (subYear === currentYear) {
        newSubscriptionsPerMonth[subMonth] += 1;
      }

      // --- Count renewals (this year only) ---
      if (sub.renewed_at) {
        const renewedAt = new Date(sub.renewed_at);
        if (renewedAt.getFullYear() === currentYear) {
          const renewedMonth = renewedAt.getMonth();
          renewalsPerMonth[renewedMonth] += 1;
        }
      }

      // --- Active vs Expired ---
      const expiryDate = new Date(createdAt);
      expiryDate.setDate(expiryDate.getDate() + sub.duration);

      if (expiryDate > now) {
        activeCount += 1;
      } else {
        expiredCount += 1;
      }
    });

    return {
      newSubscriptionsPerMonth,
      renewalsPerMonth,
      activeCount,
      expiredCount,
    };
  }, [subscriptions]);
}
